const Translation = {
    title: "株式会社和映",
    nav: {
        about: "关于我们",
        contact: "联系我们",
    },
    about: {
        title: "关于我们",
        desc_1: "株式会社和映是立足于日本·东京及中国·北京的一家电影制作及广告制作公司。",
        desc_2: "依托于成熟的电影和广告的经验在日本开展广告业务的同时致力于制作中日合拍的电影，为两国世代友好做出一个电影人应该有的贡献。"
    },
    contact: {
        title: "联系我们",
        desc_1: "Han Mengxin",
        desc_2: "TEL: +81 03-6914-4070 / +81 080-6501-0978",
        desc_3: "E-MAIL: mengxin_han@waei.one",
        desc_4: "ADDRESS: 东京都世田谷区楼 3-29-4-101",
    },
    article: {
        rental_price: "租金价格",
        characteristic:  "特性",
        accessories: "配件",
        specification: "规格",
        related_equipment: "关联设备",
    },
    common: {
        more: "更多",
    },
}

export default Translation;
